// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"485":"66ce25092edd97ee4fa1","905":"c15addb3e40eb496ba1d"}[chunkId] + ".css";
};